import { normalizePropertyMoney, sumPropertyMoney } from "./propertyLoanMoney";

export const PROPERTY_CO_OWNER_RELATIONSHIPS = [
  "Spouse",
  "Parent",
  "Child",
  "Sibling",
  "Other",
];
export const isCoOwnedProperty = (ownership) =>
  ["JointTenancy", "TenancyInCommon"].includes(ownership);
export const createEmptyPropertyCoOwner = () => ({
  name: "",
  relationship: "Spouse",
  phone: "",
  cpfUsage: null,
});
export const applicantPropertyCpfUsage = (form) =>
  normalizePropertyMoney(form.applicantCpfUsage ?? form.cpfUsage);
export const totalPropertyCpfUsage = (form) =>
  sumPropertyMoney(
    applicantPropertyCpfUsage(form),
    ...(isCoOwnedProperty(form.propertyOwnership)
      ? (form.otherOwners || []).map((owner) => owner.cpfUsage)
      : []),
  );
export const withPropertyOwnershipDetails = (form) => ({
  ...form,
  applicantCpfUsage: applicantPropertyCpfUsage(form),
  cpfUsage: totalPropertyCpfUsage(form),
  propertyShare:
    form.propertyOwnership === "TenancyInCommon" ? form.propertyShare : null,
});
export const propertyOwnershipError = (form) => {
  if (
    form.propertyOwnership === "TenancyInCommon" &&
    (!Number.isFinite(Number(form.propertyShare)) ||
      Number(form.propertyShare) <= 0 ||
      Number(form.propertyShare) > 100)
  ) {
    return "Enter your share of the property between 0 and 100%.";
  }
  if (
    isCoOwnedProperty(form.propertyOwnership) &&
    (!(form.otherOwners || []).length ||
      form.otherOwners.some(
        (owner) =>
          !owner.name?.trim() ||
          !owner.phone?.trim() ||
          !PROPERTY_CO_OWNER_RELATIONSHIPS.includes(owner.relationship) ||
          owner.cpfUsage === null ||
          owner.cpfUsage === "" ||
          !Number.isFinite(Number(owner.cpfUsage)) ||
          Number(owner.cpfUsage) < 0,
      ))
  ) {
    return "Enter each co-owner's name, relationship, mobile number and CPF housing usage (enter 0 if none).";
  }
  return null;
};
export const propertyOwnershipLabel = (ownership) =>
  ({
    Single: "Single owner",
    JointTenancy: "Joint tenancy",
    TenancyInCommon: "Tenancy-in-common",
    Joint: "Joint ownership",
    JointS: "Joint ownership (unable to provide authentication)",
  })[ownership] || ownership;
